module.exports = __webpack_public_path__ + "img/INVENTORY.15528945.svg";